module.exports = __webpack_public_path__ + "selenium.2j_cdU-U.svg";